import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import OakvaleLogo from '../OakvaleLogo';

const navLinks = [
  { name: 'Home', path: '/' },
  { name: 'About', path: '/about' },
  { name: 'Products', path: '/products' },
  { name: 'Contact', path: '/contact' }
];

const Navigation = () => {
  const location = useLocation();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav 
      className={`fixed top-0 left-0 right-0 z-[100] transition-all duration-300 ${
        isScrolled 
          ? 'bg-white/95 backdrop-blur-md shadow-card' 
          : 'bg-white/80 backdrop-blur-sm'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <OakvaleLogo />

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-1">
            {navLinks.map((link) => (
              <Link
                key={link.name}
                to={link.path}
                className={`px-3 py-2 text-sm font-medium rounded-xl transition-all duration-200
                  hover:bg-primary-50 relative group ${
                  location.pathname === link.path 
                    ? 'text-primary-800 bg-primary-50' 
                    : 'text-stone-600 hover:text-primary-800'
                }`}
              >
                {link.name}
                {location.pathname === link.path && (
                  <span className="absolute bottom-1.5 left-3 right-3 h-0.5 rounded-full bg-primary-700" />
                )}
              </Link>
            ))}
            <div className="flex items-center space-x-2 ml-4">
              <Link
                to="/login"
                className="rounded-xl px-4 py-2 text-sm font-medium text-primary-800 transition-all duration-200
                  hover:bg-primary-50 hover:text-primary-900"
              >
                Sign In
              </Link>
              <Link
                to="/signup"
                className="rounded-xl bg-gradient-to-r from-primary-700 to-primary-800 px-4 py-2 text-sm font-medium
                  text-white shadow-sm transition-all duration-300 hover:-translate-y-0.5 hover:from-primary-800
                  hover:to-primary-900 hover:shadow-md"
              >
                Open Account
              </Link>
            </div>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="inline-flex items-center justify-center rounded-xl p-2 text-stone-600 transition-colors duration-200 hover:bg-primary-50 hover:text-primary-800 md:hidden"
          >
            <span className="sr-only">Open main menu</span>
            {!isMobileMenuOpen ? (
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            ) : (
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            )}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        className={`md:hidden absolute top-16 inset-x-0 bg-white/95 backdrop-blur-md shadow-card transition-all duration-300 ease-in-out ${
          isMobileMenuOpen ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-4 pointer-events-none'
        }`}
      >
        <div className="px-4 pt-2 pb-3 space-y-1">
          {navLinks.map((link) => (
            <Link
              key={link.name}
              to={link.path}
              className={`block rounded-xl px-4 py-3 text-base font-medium transition-all duration-200 ${
                location.pathname === link.path
                  ? 'bg-primary-50 text-primary-800'
                  : 'text-stone-600 hover:bg-primary-50 hover:text-primary-800'
              }`}
              onClick={() => setIsMobileMenuOpen(false)}
            >
              {link.name}
            </Link>
          ))}
          <div className="pt-4 space-y-2">
            <Link
              to="/login"
              className="block w-full rounded-xl px-4 py-3 text-base font-medium text-primary-800 transition-all duration-200
                hover:bg-primary-50 hover:text-primary-900"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Sign In
            </Link>
            <Link
              to="/signup"
              className="block w-full rounded-xl bg-gradient-to-r from-primary-700 to-primary-800 px-4 py-3 text-base font-medium text-white"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Open Account
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navigation; 